<section class="container w-full flex-flex-col">
  <ng-container *ngIf="addProjectForm.disabled">
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </ng-container>

  <header class="container__header w-full flex flex-row items-center border-b border-gray-200 px-6 py-4">
    <p class="container__header__title w-full text-lg font-semibold">Save To View</p>
    <ts-button
      [type]="'icon'"
      [icon]="'close'"
      [color]="'basic'"
      [matTooltip]="'Close'"
      (click)="discard()"
    ></ts-button>
  </header>

  <main class="container__main w-full p-6">
    @if (data.reverseGeoCode) {
      <p class="pb-4">Based on where you dropped the pin, here's what we found:</p>
      <p><strong>• Nearest Address: </strong>{{ reverseGeoCode.address }}</p>
      @if (reverseGeoCode.city) {
        <p><strong>• City: </strong>{{ reverseGeoCode.city }}</p>
      }
      @if (reverseGeoCode.state) {
        <p><strong>• State: </strong>{{ reverseGeoCode.state }}</p>
      }
      @if (reverseGeoCode.lat && reverseGeoCode.lng) {
        <p><strong>• Latitude & Longitude: </strong>{{ reverseGeoCode.lat }}, {{ reverseGeoCode.lng }}</p>
      }
    }

    <form [formGroup]="addProjectForm" [ngClass]="{ 'pt-4': data.reverseGeoCode }">
      <mat-form-field class="w-full">
        <mat-label>What should we call this deal?</mat-label>
        <input matInput [formControlName]="'title'" />
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>Which view do you want to save it to?</mat-label>
        <mat-select [formControlName]="'pipeline_id'">
          @for (pipeline of pipelines; track pipeline.id) {
            <mat-option [value]="pipeline.id">
              {{ pipeline.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </main>

  <footer class="container__footer flex items-center justify-end gap-2 border-t border-gray-200 px-6 py-4">
    <ts-button [type]="'stroked'" [color]="'basic'" (click)="discard()"> Cancel </ts-button>
    <ts-button [type]="'flat'" [disabled]="addProjectForm.pristine || addProjectForm.invalid" (click)="save()">
      Submit
    </ts-button>
  </footer>
</section>
